import { FC } from "react";
import { Box, Flex, useBreakpointValue } from "@chakra-ui/react";

interface Props {
  bg: string;
  direction: "up" | "down";
  curveHeight?: Record<string, string>;
}

const propsByDirection = {
  up: {
    marginBottom: "-1px",
    transform: "rotate(180deg)",
  },
  down: {
    marginTop: "-1px",
    transform: "rotate(0deg)",
  },
};

export const Convex: FC<Props> = ({
  bg,
  direction,
  curveHeight = { base: "2rem", md: "4rem" },
}) => {
  const curveHeightValue = useBreakpointValue(curveHeight);
  const directionProps = propsByDirection[direction];

  return (
    <Flex position="relative">
      {/* Required to ensure curve height is respected by siblings */}
      <Box h={curveHeight} zIndex="hide" w="100%" />
      <Box
        position="absolute"
        w="100%"
        css={{
          "&::before": {
            background: bg,
            clipPath: "url(#convexDown)",
            content: '""',
            height: curveHeightValue,
            left: 0,
            position: "absolute",
            width: "100%",
            ...directionProps,
          },
        }}
      />
      <svg width="0" height="0">
        <clipPath id="convexDown" clipPathUnits="objectBoundingBox">
          <path
            d="M1 0V0.0533676C0.868246 0.641276 0.692719 1 0.5 1C0.307281 1 0.131754 0.641276 0 0.0533667L0 0H1Z"
            fill="white"
          />
        </clipPath>
      </svg>
    </Flex>
  );
};
